import { useCallback, useEffect, useState } from 'react'

import { useNavigation } from 'expo-router'

import { useStore } from '../../models'
import { PlayerGameStatsModelType } from '../../models/api-store'

const useFetchLastGameStats = () => {
  const {
    game: { getPlayerGameStats }
  } = useStore()
  const [userStats, setUserStats] = useState<PlayerGameStatsModelType>()
  const [loading, setLoading] = useState(false)
  const navigation = useNavigation()
  const isFocused = navigation.isFocused()

  const getStats = useCallback(async () => {
    setLoading(true)
    try {
      const data = await getPlayerGameStats()
      setUserStats(data)
      setLoading(false)
    } catch (e) {
      console.error(e)
      setLoading(false)
    }
  }, [getPlayerGameStats])

  useEffect(() => {
    if (isFocused) {
      getStats()
    }
  }, [getStats, isFocused])

  return {
    userStats,
    loading
  }
}

export default useFetchLastGameStats
